import { render } from "./mythVsFactThree.vue?vue&type=template&id=56fb5312"
import script from "./mythVsFactThree.vue?vue&type=script&lang=js"
export * from "./mythVsFactThree.vue?vue&type=script&lang=js"

import "./mythVsFactThree.vue?vue&type=style&index=0&id=56fb5312&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__